import { Dialog } from '@mui/material';
import React from 'react';
import flowTypes from 'new/components/flows/types/flowTypes';
import CredentialForm from './CredentialFormContainer';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { loadDataCredentialListing } from 'js/actions';

type Props = {
  id?: number;
  connectionTypes?: string[];
  onDismiss?: (source: any) => void;
  // To be used as a click callback when ButtonComponent is set
  onButtonClick?: () => void;
  onClose?: () => void;
  flowType?: keyof typeof flowTypes;
  open: boolean;
  // Indicates if this is a create operation (true) or edit operation (false)
  isCreateMode?: boolean;
};

import s from './ModalCredentialForm.module.scss';
import { useAppRepository } from 'new/state/app/repository/useAppRepository';

const handleDialogClick = (event: React.MouseEvent) => {
  event?.stopPropagation();
};

const ModalCredentialForm = (props: Props) => {
  const { connectionTypes, onDismiss, id, open, isCreateMode } = props;

  const dispatch = useAppDispatch();
  const appRepository = useAppRepository();

  const onClose = (event = null, reason = '') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    if (props.onClose) {
      setTimeout(() => {
        // Why inside a timeout? To keep the animation working
        props.onClose();
      }, 500);
    }
  };

  const onDismissForm = (source: any) => {
    onClose();
    onDismiss?.(source);

    // Only refresh credential listing if we created a new credential
    // Editing existing credentials doesn't require a full listing refresh
    if (isCreateMode) {
      const { sortCriteria } = appRepository.listing;
      dispatch(loadDataCredentialListing(1, sortCriteria, []) as any);
    }
  };

  return (
    <Dialog
      keepMounted={false}
      open={open}
      fullWidth
      onClose={onClose}
      onClick={handleDialogClick}
      className={s.dialogContainerOverride}
    >
      <CredentialForm
        isModal
        credentialId={id}
        connectionTypes={connectionTypes}
        resourceType="credentials"
        onDismiss={onDismissForm}
        className={s.formContainer}
      />
    </Dialog>
  );
};

export default ModalCredentialForm;
